/**
 * @generated SignedSource<<b34d4230a8074792347c07fa11e1c432>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorBioQuery$variables = {
  facilitySlug: string;
  instructorId: string;
  membershipTypeId: string;
};
export type InstructorBioQuery$data = {
  readonly facility: {
    readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonNoun_facility" | "useFacilityShowLessonPrices_facility" | "useGetLessonTypeOptions_facility">;
  } | null | undefined;
  readonly node: {
    readonly instructorDepartmentProfile?: {
      readonly bio: string | null | undefined;
      readonly headline: string | null | undefined;
    };
    readonly profileImage?: {
      readonly publicId: string;
    } | null | undefined;
    readonly user?: {
      readonly firstName: string;
      readonly fullName: string;
      readonly lastName: string | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_staffProfile">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_session">;
  } | null | undefined;
};
export type InstructorBioQuery = {
  response: InstructorBioQuery$data;
  variables: InstructorBioQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facilitySlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instructorId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "membershipTypeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "facilitySlug",
    "variableName": "facilitySlug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "facilitySlug"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPrices",
    "storageKey": null
  },
  (v11/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InstructorBioQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "InstructorDepartmentProfile",
                "kind": "LinkedField",
                "name": "instructorDepartmentProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StaffUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useGetLessonTypeOptions_staffProfile"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useGetLessonTypeOptions_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useFacilityShowLessonPrices_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useFacilityLessonNoun_facility"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useGetLessonTypeOptions_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InstructorBioQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "InstructorDepartmentProfile",
                "kind": "LinkedField",
                "name": "instructorDepartmentProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StaffUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "LessonTypeConnection",
                "kind": "LinkedField",
                "name": "lessonTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "lessonTypeRates",
                            "args": null,
                            "concreteType": "LessonRateConnection",
                            "kind": "LinkedField",
                            "name": "rates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LessonRateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LessonRate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "allMembershipTypes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ClientTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "membershipTypes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ClientTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v12/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "archivedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultDurationMins",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visibleToMembers",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "instructorId",
                                "variableName": "instructorId"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "durations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "items": [
                                  {
                                    "kind": "Variable",
                                    "name": "instructorIds.0",
                                    "variableName": "instructorId"
                                  }
                                ],
                                "kind": "ListValue",
                                "name": "instructorIds"
                              },
                              {
                                "kind": "Variable",
                                "name": "membershipTypeId",
                                "variableName": "membershipTypeId"
                              }
                            ],
                            "concreteType": "LessonRateConnection",
                            "kind": "LinkedField",
                            "name": "rates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LessonRateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LessonRate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleSetConnection",
                                        "kind": "LinkedField",
                                        "name": "chargeRuleSets",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRuleSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ChargeRuleSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ChargeRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "chargeRules",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ChargeRuleEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ChargeRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "duration",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "price",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "minPlayers",
                                                                "storageKey": null
                                                              },
                                                              (v11/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v11/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportsPublic",
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "publicLessonsPermissionSet",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "privateLessonsPermissionSet",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityCopyOverrides",
            "kind": "LinkedField",
            "name": "copyOverrides",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NounOverride",
                "kind": "LinkedField",
                "name": "lesson",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plural",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "singular",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "941a6f44918fc0a575e0ba36c03099b4",
    "id": null,
    "metadata": {},
    "name": "InstructorBioQuery",
    "operationKind": "query",
    "text": "query InstructorBioQuery(\n  $facilitySlug: String!\n  $instructorId: ID!\n  $membershipTypeId: ID!\n) {\n  node(id: $instructorId) {\n    __typename\n    ... on StaffProfile {\n      instructorDepartmentProfile(facilitySlug: $facilitySlug) {\n        headline\n        bio\n        id\n      }\n      profileImage {\n        publicId: renderingKey\n      }\n      user {\n        fullName\n        firstName\n        lastName\n        id\n      }\n    }\n    ...useGetLessonTypeOptions_staffProfile\n    id\n  }\n  facility(slug: $facilitySlug) {\n    ...useGetLessonTypeOptions_facility\n    ...useFacilityShowLessonPrices_facility\n    ...useFacilityLessonNoun_facility\n    id\n  }\n  session {\n    ...useGetLessonTypeOptions_session\n  }\n}\n\nfragment lessonTypeHasRateForMembershipType_lessonType on LessonType {\n  lessonTypeRates: rates {\n    edges {\n      node {\n        allMembershipTypes\n        membershipTypes {\n          edges {\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useFacilityLessonNoun_facility on Facility {\n  copyOverrides {\n    lesson {\n      plural\n      singular\n    }\n  }\n}\n\nfragment useFacilityShowLessonPrices_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  publicLessonsPermissionSet {\n    showPrices\n    id\n  }\n  privateLessonsPermissionSet {\n    showPrices\n    id\n  }\n}\n\nfragment useGetLessonTypeOptions_facility on Facility {\n  ...useFacilityShowLessonPrices_facility\n}\n\nfragment useGetLessonTypeOptions_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetLessonTypeOptions_staffProfile on StaffProfile {\n  lessonTypes(facilitySlug: $facilitySlug) {\n    edges {\n      node {\n        ...lessonTypeHasRateForMembershipType_lessonType\n        id\n        archivedAt\n        description\n        defaultDurationMins\n        name\n        visibleToMembers\n        durations(instructorId: $instructorId)\n        rates(membershipTypeId: $membershipTypeId, instructorIds: [$instructorId]) {\n          edges {\n            node {\n              chargeRuleSets {\n                edges {\n                  node {\n                    chargeRules {\n                      edges {\n                        node {\n                          duration\n                          price\n                          minPlayers\n                          id\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b06346000ef7dc3265dbfd8a3146ff0";

export default node;
